import React from 'react';

/**
 * Square checkbox — Toggle's sibling for multi-select lists. Renders as a real
 * button with `role="checkbox"` (aria-checked "mixed" when indeterminate) so it
 * stays keyboard- and screen-reader-accessible. Optional inline label.
 */
const Checkbox = ({ checked, indeterminate, onChange, disabled, size = 16, label, style }) => {
  const active = !!checked || !!indeterminate;
  const box = (
    <span style={{
      width: size, height: size, flexShrink: 0,
      borderRadius: 4,
      border: `1.5px solid ${active ? 'var(--accent)' : 'var(--line-soft)'}`,
      background: active ? 'var(--accent)' : 'transparent',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      transition: 'background 140ms var(--ease-out), border-color 140ms',
    }}>
      {indeterminate ? (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
          <rect x="1.5" y="4.25" width="7" height="1.5" rx="0.75" fill="white" />
        </svg>
      ) : checked ? (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path d="M2 5l2.5 2.5 3.5-4" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : null}
    </span>
  );

  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={indeterminate ? 'mixed' : !!checked}
      aria-label={typeof label === 'string' ? label : undefined}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      style={{
        display: 'flex', alignItems: 'center', gap: 8,
        padding: 0, border: 'none', background: 'none',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        color: 'var(--fg)',
        font: 'inherit',
        textAlign: 'left',
        ...style,
      }}
    >
      {box}
      {label != null && <span>{label}</span>}
    </button>
  );
};

export default Checkbox;
